declare global {
  interface Window {
    appInsights?: import("@microsoft/applicationinsights-web").ApplicationInsights;
  }
}

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";

// Initialize Application Insights if connection string is present
const aiConnectionString = process.env.VUE_APP_APPLICATIONINSIGHTS_CONNECTION_STRING;

if (aiConnectionString) {
  console.log("Initializing Application Insights...");
} else {
  console.warn("Application Insights connection string not provided. Telemetry will be disabled.");
}

if (aiConnectionString) {
  const appInsights = new ApplicationInsights({
    config: {
      connectionString: aiConnectionString,
      enableAutoRouteTracking: true,
    },
  });
  appInsights.loadAppInsights();
  appInsights.trackPageView();
  // Optionally make appInsights available globally
  window.appInsights = appInsights;

  // --- Console log forwarding ---
  // Only forward console logs in production to preserve line numbers during development
  if (process.env.NODE_ENV === "production") {
    const originalLog = console.log;
    console.log = function (...args) {
      appInsights.trackTrace({
        message: args.map(String).join(" "),
        severityLevel: 1, // Verbose
      });
      originalLog.apply(console, args);
    };

    const originalError = console.error;
    console.error = function (...args) {
      appInsights.trackException({ exception: new Error(args.map(String).join(" ")) });
      originalError.apply(console, args);
    };

    const originalWarn = console.warn;
    console.warn = function (...args) {
      appInsights.trackTrace({
        message: args.map(String).join(" "),
        severityLevel: 2, // Warning
      });
      originalWarn.apply(console, args);
    };
  }
}

createApp(App).use(router).mount("#app");
